import { DRP } from '../../drp';
import { PedidoItem } from '../../item';
import { PedidoIsLiberadoEntitier } from './pedido-is-liberado-entitier.interface';

/* Request com os dados para verificar se um pedido está liberado conforme as regras comerciais */
export class PedidoIsLiberadoRequest {
    id: number;
    status: number;
    tipoVenda: number;
    idPessoa: number;
    idRepresentante: number;
    idCampanha: number;
    idTabelaPreco: number;
    valorTotal: number;
    valorBonificacao: number;
    itens?: PedidoItem[];
    drp?: DRP;
    idsPedidosVendasReferenciados: number[];

    constructor(entity: PedidoIsLiberadoEntitier) {
        if (!entity) {
            return;
        }

        this.id = entity.id;
        this.status = entity.status;
        this.tipoVenda = entity.tipoVenda;
        this.idPessoa = entity.idPessoa;
        this.idRepresentante = entity.idRepresentante;
        this.idCampanha = entity.idCampanha;
        this.idTabelaPreco = entity.idTabelaPreco;
        this.valorTotal = entity.valorTotal;
        this.valorBonificacao = entity.valorTotal;
        this.itens = entity.itens;
        this.drp = entity.drp;

        // Adicionando os pedidos de vendas referênciados quando houverem
        this.idsPedidosVendasReferenciados = [];
        if (entity.pedidosBonificacoesReferencias) {
            entity.pedidosBonificacoesReferencias.forEach(pedidoReferencia => {
                this.idsPedidosVendasReferenciados.push(pedidoReferencia.idPedidoReferencia);
            });
        }
    }
}
